import React from 'react';

function Container(props) {
    return (
        <div className={props.className} style={{ bottom: 0, left: 0, position: 'fixed', right: 0, top: 0, zIndex: 42 }}>
            <Cover style={props.style} />
            {props.children}
        </div>
    );
}

function Cover(props) {
    const style = {
        backgroundColor: '#ffffff',
        height: '100%',
        left: '0',
        opacity: '0.7',
        position: 'absolute',
        top: 0,
        width: '100%',
        zIndex: 40
    };
    if (props.style) {
        for (let id in props.style) {
            style[id] = props.style[id];
        }
    }
    return (
        <div style={style} />
    );
}

function Fullscreen(props) {
    return (
        <Container {...props}>
            <Indicator style={{ position: 'fixed', top: '48%', zIndex: 40 }} />
        </Container>
    );
}

function Indicator(props) {
    return (
        <div className="loading--cont loading--center loading--visible" style={props.style}>
            <div className="loading--inn">
                <span className="loading--circle"></span>
                <span className="loading--circle"></span>
                <span className="loading--circle"></span>
            </div>
        </div>
    );
}

export {
    Container,
    Cover,
    Fullscreen,
    Indicator
}